import { apiSlice } from "./apiSlice";
import { QUESTION_IMAGES_URL } from "../constants";


export const questionImageApiSlice = apiSlice.injectEndpoints({

  endpoints: (builder) => ({

    // Get questions requiring images for a quiz
    getImageRequiredQuestions: builder.query({

      query: (quizId) => ({
        url: `${QUESTION_IMAGES_URL}/quiz/${quizId}/questions`,
      }),

      providesTags: ["QuestionImage"],

      keepUnusedDataFor: 5,

    }),



    // Upload question image
    uploadQuestionImage: builder.mutation({

      query: ({ questionId, formData }) => ({
        url: `${QUESTION_IMAGES_URL}/question/${questionId}/image`,

        method: "POST",

        body: formData,

      }),

      invalidatesTags: ["QuestionImage"],

    }),



    // Remove question image
    removeQuestionImage: builder.mutation({

      query: (questionId) => ({
        url: `${QUESTION_IMAGES_URL}/question/${questionId}/image`,

        method: "DELETE",

      }),

      invalidatesTags: ["QuestionImage"],

    }),



    // Get question image details
    getQuestionImage: builder.query({

      query: (questionId) => ({
        url: `${QUESTION_IMAGES_URL}/question/${questionId}/image`,
      }),

      providesTags: ["QuestionImage"],

      keepUnusedDataFor: 5,

    }),

  }),

});


export const {

  useGetImageRequiredQuestionsQuery,

  useUploadQuestionImageMutation,

  useRemoveQuestionImageMutation,

  useGetQuestionImageQuery,

} = questionImageApiSlice;